var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0349 30.6608L9.21885 32.8551C6.95246 33.276 5.81929 33.4864 5.16646 32.8336C4.51364 32.1806 4.72406 31.0474 5.14493 28.7809L7.33911 16.9643C7.69096 15.0696 7.86688 14.1221 8.49145 13.5497C9.11602 12.9773 10.2582 12.8655 12.5427 12.6421C14.7444 12.4267 16.8281 11.672 19 9.5L28.5 19.0008C26.3281 21.1728 25.5729 23.255 25.3572 25.457C25.1335 27.7417 25.0216 28.8841 24.4492 29.5086C23.8768 30.133 22.9295 30.309 21.0349 30.6608Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4168 24.0832C16.531 23.9394 15.721 23.5541 15.0835 22.9166M15.0835 22.9166C14.446 22.2792 14.0606 21.4691 13.9168 20.5833M15.0835 22.9166L6.3335 31.6666",
    stroke: "#A0A0A0",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 9.5C20.1278 7.83608 21.6554 5.0369 23.9186 4.76739C25.4635 4.58342 26.7435 5.86327 29.3031 8.42299L29.577 8.69689C32.1368 11.2566 33.4166 12.5365 33.2326 14.0814C32.9631 16.3446 30.1639 17.8722 28.5 19",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.a4c07b2dc36be41efe0a7421ba60b880.svg";
export { ForwardRef as ReactComponent };